import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import "./Formation.css";
import { ButtonOutside as Button } from '../../ButtonElement';
import {
    FormationContainer,
    FormationH1,
    FormationH3,
    FormationH5,
    FormationP,
    BtnWrap,
} from './FormationElements.js'

const Formation = () => {

    let schoolIconStyle = { background: "#83223c" }; //primaryColor

    return (
        <FormationContainer id="formation" className="lightBackground darkColor">
            <FormationH1>Ma formation</FormationH1>
            <VerticalTimeline dataClassName="vertical-timeline.vertical-timeline-custom-line" >
                {
                    timelineElements.map(element => {
                        return (
                            <VerticalTimelineElement
                                key={element.key}
                                date={element.date}
                                dateClassName="date"
                                iconStyle={schoolIconStyle}
                            >
                                <FormationH3>{element.title}</FormationH3>
                                <FormationH5>{element.location}</FormationH5>
                                <FormationP>{element.description}</FormationP>
                                <BtnWrap>
                                    <Button href={element.link} target="_blank"
                                    >{element.buttonText}</Button>
                                </BtnWrap>
                            </VerticalTimelineElement>
                        )
                    })
                }
            </VerticalTimeline>
        </FormationContainer >
    )
}

export default Formation


let timelineElements = [
    {
        id: 1,
        title: "IUT Informatique",
        location: "France, Bordeaux",
        description: "Parcours international et trésorière de l'asso ABEII",
        date: "Septembre 2019 - Aujourd'hui ",
        icon: "school",
        buttonText: "En savoir plus",
        link: 'https://www.iut.u-bordeaux.fr/info/',
    },
    {
        id: 2,
        title: "Bac STI2D",
        location: "France, Brive-La-Gaillarde",
        description: "Au lycée Georges Cabanis, option Systèmes d'Information Numériques",
        date: "Septembre 2016 - Juillet 2019  ",
        icon: "school",
        buttonText: "En savoir plus",
        link: 'https://www.lyceecabanis.fr/billets/Carte--des-formations-au-lycee-general-et-technologique/26',
    },
    {
        id: 3,
        title: "Cambridge certification",
        location: "France, Brive-La-Gaillarde",
        description: "Seconde section européenne option Sciences de l'Ingénieur",
        date: "Septembre 2016 - Juillet 2016 ",
        icon: "school",
        buttonText: "En savoir plus",
        link: 'https://www.lyceecabanis.fr/billets/Option-SI-CIT/67',
    },
]
